import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  padding: 16px 8px 16px 0;
  align-items: center;
  gap: 8px;

  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  background: #f5f5f5;

  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.16px;
`;

export const ButtonSpace = styled.div`
  width: 16px;
  height: 28px;

  display: flex;
  justify-content: center;
`;

export const Empty = styled.div`
  display: flex;
  height: 120px;
  justify-content: center;
  align-items: center;
  padding-top: 12px;
  gap: 8px;

  color: rgba(0, 0, 0, 0.25);

  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.2px;
`;
